<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Recepção"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.unidade"
                                label="Unidade"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.dataHoraEntrada"
                                label="Data/Hora da entrada"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.recepcionista"
                                label="Recepcionista"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.origemEntrada"
                                label="Origem de entrada"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.especialidade"
                                label="Especialidade"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.medicoSamu"
                                label="Médico(a) SAMU"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.motivoAtendimento"
                                label="Motivo do atendimento"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!!item.raat">
            <rkm-col cols="12">
                <rkm-area
                    :title="item.raat.tituloFormulario"
                    type="fieldset"
                >
                    <rkm-row v-if="!!item.raat.empresa.nome">
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.raat.empresa.nome"
                                label="Empresa"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!!item.raat.empresa.ramoAtividade || !!item.raat.empresa.telefone">
                        <rkm-col>
                            <Item
                                :get-value="() => item.raat.empresa.ramoAtividade"
                                label="Ramo da atividade"
                            />
                        </rkm-col>

                        <rkm-col cols="auto">
                            <Item
                                :get-value="() => item.raat.empresa.telefone"
                                label="Telefone"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!!item.raat.empresa.endereco">
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.raat.empresa.endereco"
                                label="Endereço da empresa"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!!item.raat.empresa.ocupacaoPaciente">
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.raat.empresa.ocupacaoPaciente"
                                label="Ocupação do paciente"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-area
                                title="Identificação do acidente"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :get-value="() => item.raat.acidente.data + (item.raat.acidente.hora ? ` ${item.raat.acidente.hora}` : '')"
                                            label="Data do acidente"
                                        />
                                    </rkm-col>

                                    <rkm-col
                                        v-if="!!item.raat.acidente.tipo"
                                        cols="auto"
                                    >
                                        <Item
                                            :get-value="() => item.raat.acidente.tipo"
                                            label="Acidente"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.acidente.regimeTrabalho">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.acidente.regimeTrabalho + (item.raat.acidente.regimeTrabalhoOutro ? ` (${item.raat.acidente.regimeTrabalhoOutro})` : '')"
                                            label="Regime de trabalho"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.acidente.local">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.acidente.local"
                                            label="Local do acidente"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.acidente.descricao">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.acidente.descricao"
                                            label="Descrição do acidente"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!!item.raat.parecerMedico">
                        <rkm-col cols="12">
                            <rkm-area
                                title="Parecer médico"
                                type="fieldset"
                            >
                                <rkm-row v-if="!!item.raat.parecerMedico.agente || item.raat.parecerMedico.causasAcidente.length > 0">
                                    <rkm-col
                                         v-if="!!item.raat.parecerMedico.agente"
                                        cols="auto"
                                    >
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.agente"
                                            label="Agente"
                                        />
                                    </rkm-col>

                                    <rkm-col v-if="item.raat.parecerMedico.causasAcidente.length > 0">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.causasAcidente.join(', ')"
                                            label="Causa do acidente"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="item.raat.parecerMedico.partesCorpoAtingidas.length > 0">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.partesCorpoAtingidas.join(', ')"
                                            label="Partes do corpo atingidas"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="item.raat.parecerMedico.diagnosticos.length > 0">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.diagnosticos.join(', ')"
                                            label="Diagnóstico"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.parecerMedico.sofreuAcidenteTrabalho">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.sofreuAcidenteTrabalho"
                                            label="Paciente sofreu acidente de trabalho"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.parecerMedico.portadorDoencaOcupacional">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.portadorDoencaOcupacional"
                                            label="Paciente é portador de doença ocupacional"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.parecerMedico.precisaInternacao">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.precisaInternacao"
                                            label="Paciente precisa de internação"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.parecerMedico.diasAfastamento">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.diasAfastamento"
                                            label="Dias de afastamento"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.parecerMedico.cid">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.cid"
                                            label="CID 10"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!!item.raat.parecerMedico.observacao">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.observacao"
                                            label="Observação"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="auto">
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.classificacaoInicial"
                                            label="Classificação inicial"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :get-value="() => item.raat.parecerMedico.comAfastamento"
                                            label="Com afastamento"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.assistenciaSocial.length > 0">
            <rkm-col cols="12">
                <rkm-area
                    title="Assistência social"
                    type="fieldset"
                >
                    <rkm-list
                        :items="item.assistenciaSocial"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                    >
                        <template v-slot="{item}">
                            <rkm-row>
                                <rkm-col cols="12">
                                    {{ item.data }} {{ item.horario }} - {{ item.profissional.nome }} - {{ item.cbo }}
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="12">
                                    <div v-html="item.anotacao"></div>
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-list>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.classificacoesRisco.length > 0">
            <rkm-col cols="12">
                <rkm-area
                    title="Classificação de risco"
                    type="fieldset"
                >
                    <rkm-list
                        :items="item.classificacoesRisco"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                    >
                        <template v-slot="{item}">
                            <rkm-row>
                                <rkm-col cols="12">
                                    {{ item.dataHora }} - <strong>{{ item.nome }}</strong> - {{ item.profissional }} - {{ item.cbo }} ({{ item.setor }})
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-list>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.fatoresRisco.length > 0">
            <rkm-col cols="12">
                <rkm-area
                    title="Fatores de risco"
                    type="fieldset"
                >
                    <rkm-list
                        :items="item.fatoresRisco"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                    >
                        <template v-slot="{item}">
                            <rkm-row>
                                <rkm-col cols="12">
                                    {{ item.dataHora }} - {{ item.nome }} - {{ item.profissional }} - {{ item.cbo }} ({{ item.setor }})
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-list>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!!item.dorToracica">
            <rkm-col cols="12">
                <rkm-area
                    title="PROTOCOLO - DOR TORÁCICA"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => `${item.formularioDorToracica.dataSintoma} ${item.formularioDorToracica.horaSintoma}`"
                                label="Data/Hora do inicio do sintoma"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => `${item.formularioDorToracica.dataEcgAdmissao} ${item.formularioDorToracica.horaEcgAdmissao}`"
                                label="Data/Hora ECG de admissão"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.formularioDorToracica.relacionados.caracteristicasDaDor.length > 0
                                    ? item.formularioDorToracica.relacionados.caracteristicasDaDor.join(' - ')
                                    : 'Nada informado'"
                                label="Características da dor"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.formularioDorToracica.relacionados.localizadoresDaDor.length > 0
                                    ? item.formularioDorToracica.relacionados.localizadoresDaDor.join(' - ')
                                    : 'Não tem informação'"
                                label="Localizador da dor"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.formularioDorToracica.relacionados.fatoresDesencadeantes.length > 0
                                    ? item.formularioDorToracica.relacionados.fatoresDesencadeantes.join(' - ')
                                    : 'Não tem informação'"
                                label="Fator desencadeante"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.formularioDorToracica.relacionados.duracaoDaDor.hasDurationInfo
                                    && item.formularioDorToracica.relacionados.duracaoDaDor.hasLongerThan5Minutes
                                    ? '> que 5 minutos'
                                    : 'menor que 5 minutos'"
                                label="Duração da dor"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.formularioDorToracica.dispneia == 1 ? 'SIM' : 'NÃO'"
                                label="Acompanhada de dispneia"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.formularioDorToracica.relacionados.fatoresDeRisco.length > 0
                                    ? item.formularioDorToracica.relacionados.fatoresDeRisco.join(' ').substring(2)
                                    : 'Não tem informação'"
                                label="Fatores de risco"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.alergias.length > 0">
            <rkm-col cols="12">
                <rkm-area
                    title="Alergias / Reações adversas"
                    type="fieldset"
                >
                    <rkm-list
                        :items="item.alergias"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                    >
                        <template v-slot="{item}">
                            <rkm-row>
                                <rkm-col cols="12">
                                    {{ item.dataHora }} - {{ item.nome }} - {{ item.profissional }} - {{ item.cbo }} ({{ item.setor }})
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-list>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.medicamentosUsoContinuo.length > 0">
            <rkm-col cols="12">
                <rkm-area
                    title="Medicamento(s) de uso contínuo"
                    type="fieldset"
                >
                    <rkm-list
                        :items="item.medicamentosUsoContinuo"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                    >
                        <template v-slot="{item}">
                            <rkm-row>
                                <rkm-col cols="12">
                                    {{ item.dataHora }} - {{ item.nome }} - {{ item.profissional }} - {{ item.cbo }} ({{ item.setor }})
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-list>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.medicamentosEmUso.length > 0">
            <rkm-col cols="12">
                <rkm-area
                    title="Medicamentos em uso"
                    type="fieldset"
                >
                    <rkm-list
                        :items="item.medicamentosEmUso"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                    >
                        <template v-slot="{item}">
                            <rkm-row>
                                <rkm-col cols="12">
                                    {{ item.dataHora }} - {{ item.descricao }} - {{ item.profissional }} - {{ item.cbo }} ({{ item.setor }})
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-list>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-for="(atendimento, i) in item.atendimentos"
            :key="i"
        >
            <rkm-col cols="12">
                <rkm-area
                    v-if="atendimento.tipo === 'triagem'"
                    :class="{ 'pb-0': !atendimento.visible }"
                    title="Triagem"
                    type="fieldset"
                >
                    <template slot="trailing">
                        <rkm-button
                            :title="atendimento.visible ? 'Ocultar' : 'Exibir'"
                            @click="atendimento.visible = !atendimento.visible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="`angle-double-${atendimento.visible ? 'up' : 'down'}`" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="atendimento.visible">
                        <rkm-row>
                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.dataHora"
                                    label="Data/Hora"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.profissional.nome"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.cbo"
                                    label="CBO"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.avaliacaoAntropometrica">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Avaliação antropométrica"
                                    type="fieldset"
                                >
                                    <rkm-row>
                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoAntropometrica.peso"
                                                label="Peso"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoAntropometrica.altura"
                                                label="Altura"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.sinaisVitais.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Sinais Vitais"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.sinaisVitais"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.pa"
                                                        label="PA"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.glicemia"
                                                        label="Glicemia"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.temperatura"
                                                        label="Temperatura"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.pulso"
                                                        label="Pulso"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row>
                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.respiracao"
                                                        label="Respiração"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.saturacao"
                                                        label="SaO2"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.intensidadeDor"
                                                        label="Intensidade da dor"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.cintura"
                                                        label="Cintura"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.historicoEnfermagem">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.historicoEnfermagem"
                                    label="Histórico de enfermagem"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.outrasAvaliacoesCondicoes">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.outrasAvaliacoesCondicoes"
                                    label="Outras avaliações e condições"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.observacoes">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.observacoes"
                                    label="Observações"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.procedimentos.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Procedimentos realizados"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.procedimentos"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-area>

                <rkm-area
                    v-if="atendimento.tipo === 'reabertura'"
                    :class="{ 'pb-0': !atendimento.visible }"
                    title="Reabertura de FAA"
                    type="fieldset"
                >
                    <template slot="trailing">
                        <rkm-button
                            :title="atendimento.visible ? 'Ocultar' : 'Exibir'"
                            @click="atendimento.visible = !atendimento.visible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="`angle-double-${atendimento.visible ? 'up' : 'down'}`" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="atendimento.visible">
                        <rkm-row>
                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.dataHora"
                                    label="Data/Hora"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.profissional.nome"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.cbo"
                                    label="CBO"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-area>

                <rkm-area
                    v-else-if="atendimento.tipo === 'medico'"
                    :class="{ 'pb-0': !atendimento.visible }"
                    :title="'Atendimento médico' + (atendimento.isObservacao ? ' (Observação)' : '')"
                    type="fieldset"
                >
                    <template slot="trailing">
                        <rkm-button
                            :title="atendimento.visible ? 'Ocultar' : 'Exibir'"
                            @click="atendimento.visible = !atendimento.visible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="`angle-double-${atendimento.visible ? 'up' : 'down'}`" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="atendimento.visible">
                        <rkm-row>
                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.dataHora"
                                    label="Data/Hora"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.profissional.nome"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.cbo"
                                    label="CBO"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.avaliacaoAntropometrica">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Avaliação antropométrica"
                                    type="fieldset"
                                >
                                    <rkm-row>
                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoAntropometrica.peso"
                                                label="Peso"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoAntropometrica.altura"
                                                label="Altura"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.sinaisVitais.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Sinais Vitais"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.sinaisVitais"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.pa"
                                                        label="PA"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.glicemia"
                                                        label="Glicemia"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.temperatura"
                                                        label="Temperatura"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.pulso"
                                                        label="Pulso"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row>
                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.respiracao"
                                                        label="Respiração"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.saturacao"
                                                        label="SaO2"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.intensidadeDor"
                                                        label="Intensidade da dor"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.cintura"
                                                        label="Cintura"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.evolucao">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.evolucao"
                                    label="Evolução médica"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.anamnsese">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.anamnsese"
                                    label="Anamnese"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.queixaPrincipalDuracao">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.queixaPrincipalDuracao"
                                    label="Queixa principal e duração"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.historiaPaciente">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.historiaPaciente"
                                    label="História do paciente"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.exameFisico">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.exameFisico"
                                    label="Exame físico"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.diagnostico">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.diagnostico"
                                    label="Diagnóstico"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.conduta">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.conduta"
                                    label="Conduta"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.observacoesServicosEnfermagem">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.observacoesServicosEnfermagem"
                                    label="Observações de serviços de enfermagem"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.observacoes">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.observacoes"
                                    label="Observações"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.servicosEnfermagem.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Serviços de enfermagem solicitados"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.servicosEnfermagem"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.exames.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Exames solicitados"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.exames"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Procedimento"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nomeExame"
                                                        label="Exame"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.prescricoesInternas.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Prescrição interna"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.prescricoesInternas"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => `${item.medicamento} ${item.quantidade} ${item.unidadeMedidaSigla}`"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.frequencia"
                                                        label="Frequência"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row v-if="!!item.administracao">
                                                <rkm-col cols="12">
                                                    <Item
                                                        :get-value="() => item.administracao"
                                                        label="Administrar"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.procedimentos.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Procedimentos realizados"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.procedimentos"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.cid">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.cid"
                                    label="CID 10 principal"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => atendimento.reavaliacao.solicitou"
                                    label="Solicitou reavaliação"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="!!atendimento.reavaliacao.dataHora"
                                cols="6"
                            >
                                <Item
                                    :get-value="() => atendimento.reavaliacao.dataHora"
                                    label="Próxima reavaliação"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-area>

                <rkm-area
                    v-else-if="(atendimento.tipo === 'enfermagem' && !atendimento.nodata) || (atendimento.tipo === 'observacao' && !atendimento.nodata)"
                    :class="{ 'pb-0': !atendimento.visible }"
                    :title="'Atendimento de enfermagem' + (atendimento.tipo === 'observacao' ? ' (Observação)' : '')"
                    type="fieldset"
                >
                    <template slot="trailing">
                        <rkm-button
                            :title="atendimento.visible ? 'Ocultar' : 'Exibir'"
                            @click="atendimento.visible = !atendimento.visible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="`angle-double-${atendimento.visible ? 'up' : 'down'}`" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="atendimento.visible">
                        <rkm-row>
                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.dataHora"
                                    label="Data/Hora"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.profissional.nome"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.cbo"
                                    label="CBO"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.dataHoraEntrada || !!atendimento.quarto || !!atendimento.leito">
                            <rkm-col
                                v-if="!!atendimento.dataHoraEntrada"
                                cols="6"
                            >
                                <Item
                                    :get-value="() => atendimento.dataHoraEntrada"
                                    label="Data/hora de entrada"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="!!atendimento.quarto"
                                cols="3"
                            >
                                <Item
                                    :get-value="() => atendimento.quarto"
                                    label="Quarto"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="!!atendimento.leito"
                                cols="3"
                            >
                                <Item
                                    :get-value="() => atendimento.leito"
                                    label="Leito"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.avaliacaoAntropometrica">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Avaliação antropométrica"
                                    type="fieldset"
                                >
                                    <rkm-row>
                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoAntropometrica.peso"
                                                label="Peso"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoAntropometrica.altura"
                                                label="Altura"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.sinaisVitais.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Sinais Vitais"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.sinaisVitais"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.pa"
                                                        label="PA"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.glicemia"
                                                        label="Glicemia"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.temperatura"
                                                        label="Temperatura"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.pulso"
                                                        label="Pulso"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row>
                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.respiracao"
                                                        label="Respiração"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.saturacao"
                                                        label="SaO2"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.intensidadeDor"
                                                        label="Intensidade da dor"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="3">
                                                    <Item
                                                        :get-value="() => item.cintura"
                                                        label="Cintura"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="'trauma' in atendimento
                            && (!!atendimento.trauma.hemorragiaExternaGrave
                                || !!atendimento.trauma.viasAereas
                                || !!atendimento.trauma.oxigenacaoRespiracaoVentilacao
                                || !!atendimento.trauma.circulacaoHemorragias.pulso
                                || !!atendimento.trauma.circulacaoHemorragias.perfusao
                                || !!atendimento.trauma.circulacaoHemorragias.pele
                                || !!atendimento.trauma.circulacaoHemorragias.sangramentos
                                || !!atendimento.trauma.avaliacaoNeurologica.pupilas
                                || !!atendimento.trauma.avaliacaoNeurologica.paresias
                                || !!atendimento.trauma.avaliacaoNeurologica.plegia
                                || !!atendimento.trauma.exposicaoHipotermia
                            )"
                        >
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Trauma"
                                    type="fieldset"
                                >
                                    <rkm-row v-if="!!atendimento.trauma.hemorragiaExternaGrave">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.trauma.hemorragiaExternaGrave"
                                                label="X - Exsanguinação hemorragia externa grave"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.trauma.viasAereas">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.trauma.viasAereas"
                                                label="A - Vias aéreas"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.trauma.oxigenacaoRespiracaoVentilacao">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.trauma.oxigenacaoRespiracaoVentilacao"
                                                label="B - Oxigenação / respiração / ventilação"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.trauma.circulacaoHemorragias.pulso
                                        || !!atendimento.trauma.circulacaoHemorragias.perfusao
                                        || !!atendimento.trauma.circulacaoHemorragias.pele
                                        || !!atendimento.trauma.circulacaoHemorragias.sangramentos"
                                    >
                                        <rkm-col cols="12">
                                            <rkm-area
                                                title="C - Circulação e hemorragias"
                                                type="fieldset"
                                            >
                                                <rkm-row v-if="!!atendimento.trauma.circulacaoHemorragias.pulso
                                                    || !!atendimento.trauma.circulacaoHemorragias.perfusao"
                                                >
                                                    <rkm-col
                                                        v-if="!!atendimento.trauma.circulacaoHemorragias.pulso"
                                                        cols="auto"
                                                    >
                                                        <Item
                                                            :get-value="() => !!atendimento.trauma.circulacaoHemorragias.pulso"
                                                            label="Pulso"
                                                        />
                                                    </rkm-col>

                                                    <rkm-col
                                                        v-if="!!atendimento.trauma.circulacaoHemorragias.perfusao"
                                                        cols="auto"
                                                    >
                                                        <Item
                                                            :get-value="() => !!atendimento.trauma.circulacaoHemorragias.perfusao"
                                                            label="Perfusão"
                                                        />
                                                    </rkm-col>
                                                </rkm-row>

                                                <rkm-row v-if="!!atendimento.trauma.circulacaoHemorragias.pele">
                                                    <rkm-col cols="12">
                                                        <Item
                                                            :get-value="() => atendimento.trauma.circulacaoHemorragias.pele"
                                                            label="Pele"
                                                        />
                                                    </rkm-col>
                                                </rkm-row>

                                                <rkm-row v-if="!!atendimento.trauma.circulacaoHemorragias.sangramentos">
                                                    <rkm-col cols="12">
                                                        <Item
                                                            :get-value="() => atendimento.trauma.circulacaoHemorragias.sangramentos"
                                                            label="Sangramentos"
                                                        />
                                                    </rkm-col>
                                                </rkm-row>
                                            </rkm-area>
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.trauma.avaliacaoNeurologica.pupilas
                                        || !!atendimento.trauma.avaliacaoNeurologica.paresias
                                        || !!atendimento.trauma.avaliacaoNeurologica.plegia"
                                    >
                                        <rkm-col cols="12">
                                            <rkm-area
                                                title="D - Avaliação neurológica"
                                                type="fieldset"
                                            >
                                                <rkm-row>
                                                    <rkm-col
                                                        v-if="!!atendimento.trauma.avaliacaoNeurologica.pupilas"
                                                        cols="4"
                                                    >
                                                        <Item
                                                            :get-value="() => !!atendimento.trauma.avaliacaoNeurologica.pupilas"
                                                            label="Pupilas"
                                                        />
                                                    </rkm-col>

                                                    <rkm-col
                                                        v-if="!!atendimento.trauma.avaliacaoNeurologica.paresias"
                                                        cols="4"
                                                    >
                                                        <Item
                                                            :get-value="() => !!atendimento.trauma.avaliacaoNeurologica.paresias"
                                                            label="Paresias"
                                                        />
                                                    </rkm-col>

                                                    <rkm-col
                                                        v-if="!!atendimento.trauma.avaliacaoNeurologica.plegia"
                                                        cols="4"
                                                    >
                                                        <Item
                                                            :get-value="() => !!atendimento.trauma.avaliacaoNeurologica.plegia"
                                                            label="Plegia"
                                                        />
                                                    </rkm-col>
                                                </rkm-row>
                                            </rkm-area>
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.trauma.exposicaoHipotermia">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.trauma.exposicaoHipotermia"
                                                label="E - Exposição e hipotermia"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="'avaliacaoTraumaParteCorpo' in atendimento
                            && (!!atendimento.avaliacaoTraumaParteCorpo.cabecaPescoco
                                || !!atendimento.avaliacaoTraumaParteCorpo.torax
                                || !!atendimento.avaliacaoTraumaParteCorpo.abdome
                                || !!atendimento.avaliacaoTraumaParteCorpo.mmssMmii
                            )"
                        >
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Avaliação do trauma por partes do corpo"
                                    type="fieldset"
                                >
                                    <rkm-row v-if="!!atendimento.avaliacaoTraumaParteCorpo.cabecaPescoco">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoTraumaParteCorpo.cabecaPescoco"
                                                label="Cabeça e pescoço"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.avaliacaoTraumaParteCorpo.torax">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoTraumaParteCorpo.torax"
                                                label="Tórax"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.avaliacaoTraumaParteCorpo.abdome">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoTraumaParteCorpo.abdome"
                                                label="Abdome"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row v-if="!!atendimento.avaliacaoTraumaParteCorpo.mmssMmii">
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => atendimento.avaliacaoTraumaParteCorpo.mmssMmii"
                                                label="MMSS e MMII"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="'escalasGlasgow' in atendimento && atendimento.escalasGlasgow.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Escala de Glasgow"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.escalasGlasgow"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="2">
                                                    <Item
                                                        :get-value="() => item.ocular"
                                                        label="Ocular"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        :get-value="() => item.verbal"
                                                        label="Verbal"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        :get-value="() => item.motora"
                                                        label="Motora"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        :get-value="() => item.pupilar"
                                                        label="Pupilar"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        :get-value="() => item.pontuacao"
                                                        label="Pontuação"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <Item
                                                        :get-value="() => item.resultado"
                                                        label="Resultado"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.historico">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.historico"
                                    label="Histórico de enfermagem"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.diagnostico">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.diagnostico"
                                    label="Diagnóstico de enfermagem"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.planejamento">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.planejamento"
                                    label="Planejamento de enfermagem"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.implementacao">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.implementacao"
                                    label="Implementação"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.avaliacao">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.avaliacao"
                                    label="Avaliação de enfermagem"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.observacoes">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.observacoes"
                                    label="Observações"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.anotacoesEnfermagem.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Anotações de enfermagem"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.anotacoesEnfermagem"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="12">
                                                    <Item
                                                        :get-value="() => `${item.dataHora} - ${item.descricao}`"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.examesLaboratoriais.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Exames laboratoriais"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.examesLaboratoriais"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.status"
                                                        label="Status"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="'examesImagem' in atendimento && atendimento.examesImagem.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Exames de imagem"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.examesImagem"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.status"
                                                        label="Status"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.laudos.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Laudo"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.laudos"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="12">
                                                    <Item
                                                        :get-value="() => item.nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.servicosEnfermagem.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Serviço de enfermagem"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.servicosEnfermagem"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.status"
                                                        label="Status"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row v-if="!!item.observacoes">
                                                <rkm-col cols="12">
                                                    <Item
                                                        :get-value="() => item.observacoes"
                                                        label="Observação"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.prescricoesInternas.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Prescrição interna"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.prescricoesInternas"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => `${item.medicamento} ${item.quantidade} ${item.unidadeMedidaSigla}`"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.frequencia"
                                                        label="Frequência"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row v-if="!!item.administracao">
                                                <rkm-col cols="12">
                                                    <Item
                                                        :get-value="() => item.administracao"
                                                        label="Administrar"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <template v-if="item.aplicacoes.length > 0">
                                                <rkm-row
                                                    v-for="(aplicacoesRow, i) in getAplicacoesRows(item.aplicacoes)"
                                                    :key="i"
                                                >
                                                    <rkm-col
                                                        v-for="(aplicacao, i) in aplicacoesRow"
                                                        :key="i"
                                                        cols="4"
                                                    >
                                                        {{ aplicacao.numero }}ª aplicação: {{ aplicacao.status }}
                                                    </rkm-col>
                                                </rkm-row>
                                            </template>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.procedimentos.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Procedimentos realizados"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.procedimentos"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-area>

                <rkm-area
                    v-else-if="atendimento.tipo === 'exame_imagem'"
                    :class="{ 'pb-0': !atendimento.visible }"
                    :title="'Exame de imagem' + (atendimento.isObservacao ? ' (Observação)' : '')"
                    type="fieldset"
                >
                    <template slot="trailing">
                        <rkm-button
                            :title="atendimento.visible ? 'Ocultar' : 'Exibir'"
                            @click="atendimento.visible = !atendimento.visible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="`angle-double-${atendimento.visible ? 'up' : 'down'}`" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="atendimento.visible">
                        <rkm-row v-if="atendimento.examesImagem.length > 0">
                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.dataHora"
                                    label="Data/Hora"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.profissional.nome"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.cbo"
                                    label="CBO"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.examesImagem.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Exame"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.examesImagem"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Procedimento"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nomeExame"
                                                        label="Exame"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.status"
                                                        label="Status"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.procedimentos.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Procedimentos realizados"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.procedimentos"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="atendimento.laudos.length > 0">
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Laudo"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.laudos"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="12">
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.observacoes">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.observacoes"
                                    label="Observações"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-area>

                <rkm-area
                    v-else-if="atendimento.tipo === 'fechamento'"
                    :class="{ 'pb-0': !atendimento.visible }"
                    title="Fechamento de FAA"
                    type="fieldset"
                >
                    <template slot="trailing">
                        <rkm-button
                            :title="atendimento.visible ? 'Ocultar' : 'Exibir'"
                            @click="atendimento.visible = !atendimento.visible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="`angle-double-${atendimento.visible ? 'up' : 'down'}`" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="atendimento.visible">
                        <rkm-row>
                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.dataHora.split(' ')[0]"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.profissional.nome"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => atendimento.cbo"
                                    label="CBO"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-area
                                    title="Procedimentos realizados"
                                    type="fieldset"
                                >
                                    <rkm-list
                                        :items="atendimento.procedimentos"
                                        hide-filters
                                        hide-pagination
                                        item-cursor="default"
                                    >
                                        <template v-slot="{item}">
                                            <rkm-row>
                                                <rkm-col cols="auto">
                                                    <Item
                                                        :get-value="() => item.codigo"
                                                        label="Código"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="6">
                                                    <Item
                                                        :get-value="() => item.nome"
                                                        label="Nome"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </template>
                                    </rkm-list>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="!!atendimento.cid">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => atendimento.cid"
                                    label="CID 10 principal"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!!item.exclusaoFaa">
            <rkm-col cols="12">
                <rkm-area
                    title="Desfecho"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.exclusaoFaa.dataHora"
                                label="Data/Hora"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.exclusaoFaa.profissional"
                                label="Profissional"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <Item
                                :get-value="() => item.exclusaoFaa.cbo"
                                label="CBO"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => 'FAA EXCLUÍDA'"
                                label="Desfecho"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!!item.desfecho">
            <rkm-col cols="12">
                <rkm-area
                    title="Desfecho"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.desfecho.dataHora"
                                label="Data/Hora"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.desfecho.profissional"
                                label="Profissional"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <Item
                                :get-value="() => item.desfecho.cbo"
                                label="CBO"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.desfecho.nome"
                                label="Desfecho"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!!item.desfecho.evasao">
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.desfecho.evasao.motivo"
                                label="Motivo da evasão"
                            />
                        </rkm-col>
                    </rkm-row>

                    <template v-if="!!item.desfecho.encaminhamentoHospitalar">
                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.desfecho.encaminhamentoHospitalar.unidadeEncaminhamento"
                                    label="Unidade de encaminhamento"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.desfecho.encaminhamentoHospitalar.quarto"
                                    label="Quarto"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.desfecho.encaminhamentoHospitalar.leito"
                                    label="Leito"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.desfecho.encaminhamentoHospitalar.medicoHospitalar"
                                    label="Médico hospitalar"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.desfecho.encaminhamentoHospitalar.cid"
                                    label="CID10"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.desfecho.encaminhamentoHospitalar.observacoes"
                                    label="Observações"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-if="!!item.desfecho.obito">
                        <rkm-row>
                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.desfecho.obito.data"
                                    label="Data de óbito"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.desfecho.obito.hora"
                                    label="Hora de óbito"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.desfecho.obito.numeroDeclaracao"
                                    label="Número da declaração de óbito"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.desfecho.obito.cid"
                                    label="CID10"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.desfecho.obito.causa"
                                    label="Causa do óbito"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
    methods: {
        getAplicacoesRows(aplicacoes) {

            const rows = []
            let row = []

            for (let i = 0; i < aplicacoes.length; i++) {

                row.push(aplicacoes[i])

                if ((i + 1) % 3 === 0 || i === (aplicacoes.length - 1)) {

                    rows.push(row)

                    row = []
                }
            }

            return rows
        }
    }
}
</script>